import type { UIResultCommandInterface } from '@nts/std/interfaces';
import { UIResultCommand } from './ui-result-command';

export class UICommand extends UIResultCommand<void> implements UIResultCommandInterface<void> {

}
